// sanity.js
import {createClient} from '@sanity/client'
// Import using ESM URL imports in environments that supports it:
// import {createClient} from 'https://esm.sh/@sanity/client'

const sanityProjectId = import.meta.env.VITE_SANITY_PROJECT_ID;
const sanityDataset = import.meta.env.VITE_SANITY_DATASET;
const sanityUseCdn = import.meta.env.VITE_SANITY_USE_CDN;

export const client = createClient({
  projectId: sanityProjectId,
  dataset: sanityDataset,
  useCdn: sanityUseCdn, // true, // set to `false` to bypass the edge cache
  apiVersion: '2023-05-28', // use current date (YYYY-MM-DD) to target the latest API version
})

import imageUrlBuilder from '@sanity/image-url'
const builder = imageUrlBuilder(client);

export function urlFor(source) {    
  return builder.image(source)
}